<template>
    <v-row
        align="center"
        justify="center"
    >
        <v-col
            cols="12"
            lg="11"
        >
            <ReportSitesComplete />
        </v-col>
    </v-row>
</template>

<script>

import ReportSitesComplete from '@/reports/ReportSitesComplete';
export default {
    components: { ReportSitesComplete },
    props: [],

    data() {
        return {};
    },

    mounted() {
    },

    methods: {}
};
</script>
